export const authTranslations = {
  en: {
    createAccount: 'Create Account',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    email: 'Email',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    allFieldsRequired: 'All fields are required',
    passwordsNotMatch: 'Passwords do not match',
    haveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    signingUp: 'Creating account...',
    signingIn: 'Signing in...'
  },
  vi: {
    createAccount: 'Tạo tài khoản',
    signUp: 'Đăng ký',
    signIn: 'Đăng nhập',
    email: 'Email',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    allFieldsRequired: 'Vui lòng điền đầy đủ thông tin',
    passwordsNotMatch: 'Mật khẩu không khớp',
    haveAccount: 'Đã có tài khoản?',
    dontHaveAccount: 'Chưa có tài khoản?',
    signingUp: 'Đang tạo tài khoản...',
    signingIn: 'Đang đăng nhập...'
  }
};
